import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';
import { ResponsiveModal } from './responsive-modal';
import { Button } from './base';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  variant?: 'danger' | 'primary';
}

export const ConfirmationModal: FC<ConfirmationModalProps> = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  message, 
  confirmText, 
  cancelText,
  variant = 'danger'
}) => {
  const { t } = useTranslation();

  return (
    <ResponsiveModal 
        open={isOpen} 
        onOpenChange={(open) => !open && onClose()}
        title={title}
        description={message}
        className="max-w-[360px]"
    >
      <div className="flex flex-col items-center text-center">
        <div className={`w-14 h-14 rounded-full flex items-center justify-center ${variant === 'danger' ? 'bg-red-50 dark:bg-red-950/40 text-red-600 dark:text-red-400' : 'bg-blue-50 dark:bg-blue-950/40 text-blue-600 dark:text-blue-400'}`}>
          <AlertTriangle size={28} />
        </div>
        
        <div className="flex flex-col w-full gap-2 mt-5">
          <Button 
            variant={variant === 'danger' ? 'danger' : 'primary'} 
            onClick={onConfirm}
            className="w-full h-12 text-sm font-bold rounded-xl"
          >
            {confirmText || t('common.confirm', 'Подтвердить')}
          </Button>
          <Button 
            variant="ghost" 
            onClick={onClose}
            className="w-full h-12 text-sm font-bold text-slate-400"
          >
            {cancelText || t('common.cancel', 'Отмена')}
          </Button>
        </div>
      </div>
    </ResponsiveModal>
  );
};
